import axios from "axios";

export function getBaseUrl() {
    const host = window.location.host;
    const isTest = host.indexOf("mobtest.my.jj.cn") >= 0;
    const url = isTest ? "/pxyiad" : "";
    return url;
}

const baseUrl = getBaseUrl();

// /**
//  * 获取验证码
//  */
// export async function getCode(phone: string) {
//     const url = `${baseUrl}/cloudplt/api/login/user/sms/send?sname=hxzyy&gameId=3036&jjId=0&bId=70038&p=${phone}`;
//     try {
//         const res = await axios.get(url);
//         return res?.data || {};
//     } catch (e) {
//         return { REV: false, MSG: "上传失败", DATA: {} };
//     }
// }

// /**
//  * 登录
//  */
// export async function login(params: any) {
//     const { phone, code, szFCode, dwOrderID } = params;
//     const ext = encodeURIComponent(JSON.stringify({ SITEID: 4573761 }));
//     const url = `${baseUrl}/cloudplt/api/alps/user/hxz/sms/check?sname=hxzyy&gameId=3036&b=1&auto_reg=1&prod_id=20027&ext=${ext}&p=${phone}&c=${code}&szFCode=${szFCode}&oid=${dwOrderID}&appId=hxz`;
//     try {
//         const res = await axios.get(url);
//         return res?.data || {};
//     } catch (e) {
//         return { REV: false, MSG: "登录失败", DATA: {} };
//     }
// }

// /**
//  * 用户信息（登录,预约，邀请）
//  */
// export async function getUserInfo(params: any = {}) {
//     const { cid = "" } = params;
//     const url = `${baseUrl}/cloudplt/api/interestruler/user/hxz/vote/pid/list?sname=hxzyy&gameId=3036&activity=hxzyy_3036&type=8&uid=0&cid=${cid}&appId=hxz&rank=0`;
//     try {
//         const res = await axios.get(url);
//         return res?.data || { REV: false, MSG: "获取失败", DATA: { hasLogin: false, votes: [], invite: 0 } };
//     } catch (e) {
//         return { REV: false, MSG: "获取失败", DATA: { hasLogin: false, votes: [], invite: 0 } };
//     }
// }

// /**
//  * 用户预约
//  */
// export async function doOrder(params: any) {
//     const { pid, cid, code } = params;
//     const url = `${baseUrl}/cloudplt/api/interestruler/user/hxz/vote/do?sname=hxzyy&gameId=3036&activity=hxzyy_3036&action=1&type=8&uid=0&cid=${cid}&pid=${pid}&code=${code}&appId=hxz`;
//     try {
//         const res = await axios.get(url);
//         return res?.data || {};
//     } catch (e) {
//         return { REV: false, MSG: "预约失败", DATA: {} };
//     }
// }

// -------------------------------------------
/**
 * 验证游戏角色id
 */
export async function getRole(roleId: string) {
    const url = `${baseUrl}/cloudplt/api/ibbs-hxz/user/order/invite/down/role?roleId=${roleId}`;
    try {
        const res = await axios.get(url);
        return res?.data || {};
    } catch (e) {
        return { rev: false, msg: "获取角色失败", data: "" };
    }
}

/**
 * 获取短信验证码
 */
export async function getMessageCode(params: any) {
    const { p, roleId } = params;
    const url = `${baseUrl}/cloudplt/api/ibbs-hxz/user/order/invite/down/sms/send?p=${p}&roleId=${roleId}`;
    try {
        const res = await axios.post(url);
        return res?.data || {};
    } catch (e) {
        return { rev: false, msg: "获取验证码失败", data: {} };
    }
}

/**
 * 手机号验证领取下载皮肤
 */
export async function drawDownload(params: any) {
    const { p, roleId, checkcode, verifycode, orderid, code } = params;
    const url = `${baseUrl}/cloudplt/api/ibbs-hxz/user/order/invite/down/sms/check?p=${p}&roleId=${roleId}&checkcode=${checkcode}&verifycode=${verifycode}&orderid=${orderid}&code=${code}`;
    try {
        const res = await axios.post(url);
        return res?.data || {};
    } catch (e) {
        return { rev: false, msg: "验证失败", data: {} };
    }
}
